var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="FavPersAbsentVisibility MenuItem">\n	<div class=\'activateAbsentVisibilityStatus\'>\n		<div class="MenuInline MenuIcon">\n			<i class="fa fa-suitcase"></i>\n		</div>\n		<div class="MenuInline MenuLabel">\n			';
 if(active){ 
__p+='\n			Abwesende automatisch\n			';
 } else { 
__p+='\n			Abwesende automatisch auswählen\n			';
 } 
__p+='\n		</div>\n	</div>\n	';
 if(active){ 
__p+='\n	<div class="MenuSubLevel MenuButton '+
((__t=( mode === 'hide' ? 'MenuAccent' : '' ))==null?'':__t)+
' setHideMode"><i class="fa fa-eye-slash"></i>&nbsp;verstecken</div>\n	<div class="MenuSubLevel MenuButton '+
((__t=( mode === 'show' ? 'MenuAccent' : '' ))==null?'':__t)+
' setShowMode"><i class="fa fa-eye"></i>&nbsp;anzeigen</div>\n	<div class="MenuSubLevel MenuButton deactivateAbsentVisibilityStatus"><i class="fa fa-power-off" style="color:darkred"></i>&nbsp;Funktion deaktivieren\n	</div>\n	';
 } 
__p+='\n</div>\n';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
